import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const IsAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.role === 'Admin';
};